import React from 'react';
import loader from './loader.svg';

const OpacityPreLoader = () => (
  <div hidden="">
    <div className="loader loader-overlay">
      <div className="loader-icon spinning-cog loader-icon-md">
        <img alt="Загрузка" src={loader} />
      </div>
    </div>
  </div>
);
export default OpacityPreLoader;



// WEBPACK FOOTER //
// ./src/components/Common/PreLoaders/OpacityPreLoader.js